(function(){
    'use strict';
    angular
    .module('app')
    .controller('WorkflowController', WorkflowController)
    WorkflowController.$inject = ["FieldsService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
    function WorkflowController(FieldsService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.config = {};
        vm.type = "";
        vm.config.condiciones = [];
        vm.fields = [];
        vm.tareas = [];
        vm.getCampos = function(){
          FieldsService.getFieldsByNode(vm.type,false,function(data){
            	vm.fields = data.fields;
      		});
        }
        vm.parJson = function (json) {
	        return JSON.parse(json);
	    }

        vm.modalTareaEmail = "";
        vm.addTareaEmail = function(){
            vm.modalTareaEmail = $uibModal.open({
                  animation: true,
                  //windowClass : 'modal-success',
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'tareaemail.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.parametros = {};
                    console.log(vm.fields);
                    $scope.fields = vm.fields;
                    $scope.type = vm.type;
                    $scope.okForm = function(){
                        vm.tareas.push({"label":$scope.label,"funcion":"Email sendEmail","parametros":$scope.parametros});
                        vm.modalTareaEmail.close();
                    }
                    $scope.koForm = function(){
                        vm.modalTareaEmail.close();
                    }
                  }
            });
        }


        vm.modalTareaFuncion = "";
        vm.addTareaFuncion = function(){
            vm.modalTareaFuncion = $uibModal.open({
                  animation: true,
                  //windowClass : 'modal-success',
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'tareafuncion.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.parametros = {};
                    $scope.fields = vm.fields;
                    $scope.okForm = function(){
                        vm.tareas.push({"label":$scope.label,"funcion":$scope.funcion,"parametros":$scope.parametros});
                        vm.modalTareaFuncion.close();
                    }
                    $scope.koForm = function(){
                        vm.modalTareaFuncion.close();
                    }
                  }
            });
        }
    } 
})();